import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [];

const baseService = createCrudService("caregivers", customRoutes, router);

export const caregiversService = {
  ...baseService,
  list: (params) => api.getCall("/api/caregivers", params), // Override the base list method to accept params
  listPaginated: (params) => api.getCall("/api/caregivers/paginated", params),
  getAvailable: (params) => api.getCall("/api/caregivers/available", params),
  getLeads: () => api.getCall("/api/caregivers/leads"),
  getAdmins: () => api.getCall("/api/caregivers/admins"),
};
